import React, { Component } from 'react';
 import "./App.css";
import {
  BrowserRouter as Router,
  Route
} from 'react-router-dom';
import LoginPage from './components/LoginPage/LoginPage';
import HomePage from './components/Home/HomePage';
import Chargeback from './components/ChargeBack/Chargeback';
import FileUploadChargeBack from './components/ChargeBack/FileUpload';
import csscodes from './components/CSSCodes/Csscodes';
import cssFileUpload from './components/CSSCodes/FileUpload';
import shippingrates from './components/ShippingRates/ShippingRate';
import shippingratesUpload from './components/ShippingRates/FileUpload';
import midbaselines from './components/MidBaselines/MidBaselines';
import midbaselinesUpload from './components/MidBaselines/FileUpload';

import products from './components/Products/Products';
import productsUpload from './components/Products/FileUpload';

import cssnotes from './components/CSSNotes/Cssnotes';
import cssnotesFileupload from './components/CSSNotes/FileUpload';


import everflow from './components/Everflow/Everflow';
import everflowUpload from './components/Everflow/FileUpload';

import campaigns from './components/Campaigns/Campaigns';
import campaignsUpload from './components/Campaigns/FileUpload';

import Firstmile from './components/Firstmile/Firstmile';
import FirstmileUpload from './components/Firstmile/FileUpload';


import Transactions from './components/Transactions/Transactions';
import TransactionsUpload from './components/Transactions/FileUpload';


import DownloadTable from './components/Exports/Download';

import Gateways from './components/Gateways/Gateways';
import GatewaysUpload from './components/Gateways/FileUpload';

import Affiliates from './components/Affiliates/Affilates';
import AffiliatesUpload from './components/Affiliates/FileUpload';

import Users from './components/Users/Users';
import UsersForm from './components/Users/UserForm';
import UsersEditForm from './components/Users/UserEditForm';

/****************************** Reports  *******************************/

import GatewayBaselineGenerator from './components/reports/GatewayBaselineGenerator/GatewayBaselineGenerator';



import chargebackRefundReturn from './components/reports/ChargebackRefund/ChargebackRefundReturn';
import chargebackRefundSale from './components/reports/ChargebackRefund/ChargebackRefundSale';



/****** Profits Diagnosis *****/


/************* Full View  *****/

import byAllTraffic from './components/reports/ProfitabilityDiagnosis/js/fullview/ByAllTraffic';

import ByAffiliates from './components/reports/ProfitabilityDiagnosis/js/fullview/ByAffiliates';

import ByGroupCategory from './components/reports/ProfitabilityDiagnosis/js/fullview/ByGroupCategory';

import ByCampaignID from './components/reports/ProfitabilityDiagnosis/js/fullview/ByCampaignID';

import ByParentSKU from './components/reports/ProfitabilityDiagnosis/js/fullview/ByParentSKU';

import ByOfferID from './components/reports/ProfitabilityDiagnosis/js/fullview/ByOfferID';



/************* Summary  *****/

import byAllTrafficS from './components/reports/ProfitabilityDiagnosis/js/summary/ByAllTraffic';

import ByAffiliatesS from './components/reports/ProfitabilityDiagnosis/js/summary/ByAffiliates';

import ByGroupCategoryS from './components/reports/ProfitabilityDiagnosis/js/summary/ByGroupCategory';

import ByCampaignIDS from './components/reports/ProfitabilityDiagnosis/js/summary/ByCampaignID';

import ByParentSKUS from './components/reports/ProfitabilityDiagnosis/js/summary/ByParentSKU';

import ByOfferIDS from './components/reports/ProfitabilityDiagnosis/js/summary/ByOfferID';

import Tiered from './components/reports/ProfitabilityDiagnosis/js/Tiered/Tiered';

/*******  Tiered Dev ******/

import TieredDev from './components/reports/ProfitabilityDiagnosis/js/TieredNew/Complete';

import Revboost from './components/reports/ProfitabilityDiagnosis/Revboost';

import RevboostRetention from './components/reports/ProfitabilityDiagnosis/RevboostRetention';

import ProductsInfo from './components/reports/ProfitabilityDiagnosis/ProductsInfo';

import RevboostChargebackDetail from './components/reports/Revboost/RevboostChargebackDetail';

import Consumption from './components/reports/SalesPerformanceReports/Consumption';

import AffiliateByParentSKU from './components/reports/SalesPerformanceReports/AffiliateByParentSKU';

import AffiliateReview from './components/reports/SalesPerformanceReports/AffiliateReview';

import scrubReviewReport from './components/reports/SalesPerformanceReports/ScrubReviewReport';


/******************** Gateway Report *****************************/

import DeclinePercentageGenerator from './components/reports/DeclinePercentageGenerator/DeclinePercentageGenerator';


/******************** TakeRate Report *****************************/

import TakeRate from './components/reports/TakeRate/TakeRate';



/******************Shipping Reports ************************/

import shipcostpickupdate from './components/reports/ShippingReports/Shipcostbypickupdate';
// import Shipcostbyoffer from './components/reports/ShippingReports/Shipcostbyoffer';

import Shipcostbyoffer from './components/reports/ShippingReports/Shipcostbyoffer';

import OfferFF from './components/reports/ShippingReports/OfferFF';

/**************  Decline Reason Report*********/

import DeclineReasonReport from './components/reports/DeclineReasonReport/DeclineReasonReport'

/**************  Master Gateway Performance *********/

import MasterGatewayPerformance from './components/reports/MasterGatewayPerformance/MasterGatewayPerformance';

/*********** VIP ***************/
import VipRevenue from './components/reports/Vip/VipRevenue';
import VipRetention from './components/reports/Vip/VipRetention';


import NetworkvsKlaviyoReport from './components/reports/CustomerServiceReports/NetworkvsKlaviyoReport';

import Csnoteswithoutcodes from './components/reports/CustomerServiceReports/Csnoteswithoutcodes';

import Welcome from './components/Welcome/Welcome';

import profile from './components/Profile/Profile';

import './App.css';

import FirstmileCostAnalysis from './components/reports/ShippingReports/FirstmileCostAnalysis';


import Shipstation from './components/Shipstation/Shipstation';

import ShipstationUpload from './components/Shipstation/FileUpload'


const Home = () => (
  <HomePage />
);

const Login = () => (
  <LoginPage />
);




class App extends Component {
  
  
  render() {
    return (
      <Router>
        <div className="App">
        <Route  path="/login" component={Login} />
        <Route exact path="/" component={Login} />
          <Route  path="/home" component={Home} />
          <Route  path="/viewCB911" component={Chargeback} />
          <Route  path="/uploadCB911" component={FileUploadChargeBack} />
          <Route  path="/viewcscodes" component={csscodes} />
          <Route  path="/uploadCscodes" component={cssFileUpload} />
          <Route  path="/uploadShippingRates" component={shippingratesUpload} />
          <Route  path="/viewShippingRates" component={shippingrates} />
          <Route  path="/uploadMidBaselines" component={midbaselinesUpload} />
          <Route  path="/viewMidBaselines" component={midbaselines} />

          <Route  path="/uploadProducts" component={productsUpload} />
          <Route  path="/viewproducts" component={products} />
          <Route  path="/uploadCsnotes" component={cssnotesFileupload} />
          <Route  path="/viewcsnotes" component={cssnotes} />

          <Route  path="/uploadeverflow" component={everflowUpload} />
          <Route  path="/viewEverflow" component={everflow} />

          <Route  path="/uploadCampaigns" component={campaignsUpload} />
          <Route  path="/viewCampaigns" component={campaigns} />

          <Route  path="/uploadFirstmile" component={FirstmileUpload} />
          <Route  path="/viewFirstmile" component={Firstmile} />


          <Route  path="/uploadTransactions" component={TransactionsUpload} />
         
          <Route  path="/viewTransactions" component={Transactions} />
          

          <Route  path="/uploadAffiliates" component={AffiliatesUpload} />
          <Route  path="/viewAffiliates" component={Affiliates} />

          <Route  path="/uploadGateways" component={GatewaysUpload} />
          <Route  path="/viewGateways" component={Gateways} />

          <Route  path="/addUser" component={UsersForm} />
          <Route  path="/users" component={Users} />
          <Route  path="/editUser/:id" component={UsersEditForm} />


          <Route  path="/uploadShipstation" component={ShipstationUpload} />
         
          <Route  path="/viewShipstation" component={Shipstation} />
          


          <Route  path="/reports/gatewayBaselineGenerator" component={GatewayBaselineGenerator} />

          {/* By Date of Sale */}
          {/* <Route  path="/reports/chargebackRefundSale/ProductCategory" component={chargebackRefundSaleByProductCategory} />
          <Route  path="/reports/chargebackRefundSale/AFFID" component={chargebackRefundSaleByAFFID} />

          <Route  path="/reports/chargebackRefundSale/C1" component={ChargebackRefundSaleByC1} /> */}

          

          {/* By Date of Return */}
          {/* <Route  path="/reports/chargebackRefundReturn/ProductCategory" component={chargebackRefundReturnByProductCategory} />
          <Route  path="/reports/chargebackRefundReturn/AFFID" component={chargebackRefundReturnByAFFID} />

          <Route  path="/reports/chargebackRefundReturn/C1" component={ChargebackRefundReturnByC1} /> */}

          <Route  path="/reports/chargebackRefundReturn/:type" component={chargebackRefundReturn} />

          <Route  path="/reports/chargebackRefundSale/:type" component={chargebackRefundSale} />

          
  


          
          <Route  path="/welcome" component={Welcome} />
          <Route  path="/profile" component={profile} />


          <Route  path="/reports/profitsdiagnosis/fullview/byAllTraffic" component={byAllTraffic} />

          <Route  path="/reports/profitsdiagnosis/fullview/byAffiliates" component={ByAffiliates} />

          <Route  path="/reports/profitsdiagnosis/fullview/byGroupCategory" component={ByGroupCategory} />

          <Route  path="/reports/profitsdiagnosis/fullview/byCampaignID" component={ByCampaignID} />

          <Route  path="/reports/profitsdiagnosis/fullview/byParentSKU" component={ByParentSKU} />
          
          <Route  path="/reports/profitsdiagnosis/fullview/byOfferID" component={ByOfferID} />

          


          <Route  path="/reports/profitsdiagnosis/summary/byAllTraffic" component={byAllTrafficS} />

          <Route  path="/reports/profitsdiagnosis/summary/byAffiliates" component={ByAffiliatesS} />

          <Route  path="/reports/profitsdiagnosis/summary/byGroupCategory" component={ByGroupCategoryS} />

          <Route  path="/reports/profitsdiagnosis/summary/byCampaignID" component={ByCampaignIDS} />

          <Route  path="/reports/profitsdiagnosis/summary/byParentSKU" component={ByParentSKUS} />

          <Route  path="/reports/profitsdiagnosis/summary/byOfferID" component={ByOfferIDS} />

          

          <Route  path="/reports/salesperformance/consumption" component={Consumption} />

          <Route  path="/reports/salesperformance/affiliateReportingByParentSKU" component={AffiliateByParentSKU} />

          <Route  path="/reports/salesperformance/AffiliateReview" component={AffiliateReview} />

          <Route  path="/reports/salesperformance/scrubReviewReport" component={scrubReviewReport} />

          
          

          <Route  path="/reports/profitsdiagnosis/tiered/:type" component={Tiered} exact />

          {/* <Route  path="/reports/profitsdiagnosis/tiered/campaign" component={Tiered} exact />
          <Route  path="/reports/profitsdiagnosis/tiered/campaign_group" component={Tiered} exact /> */}


          <Route  path="/reports/declinePercentageGenerator/:type" component={DeclinePercentageGenerator}  />



          

          <Route  path="/reports/shippingreports/shipcostpickupdate/" component={shipcostpickupdate}  />
          <Route  path="/reports/shippingreports/shipcostbyoffer/" component={Shipcostbyoffer}  />
          <Route  path="/reports/shippingreports/offerff" component={OfferFF}  />
          
          

          <Route  path="/reports/shippingreports/firstmilecostanalysis" component={FirstmileCostAnalysis}  />


          <Route  path="/reports/TakeRate/:type" component={TakeRate}  />
          {/* <Route  path="/reports/TakeRate/:type" component={TakeRate}  /> */}



          

          <Route  path="/reports/fullviewdev/" component={TieredDev}  />
          <Route  path="/reports/profitsdiagnosis/profitview" component={TieredDev}  />
          <Route  path="/asuser/:username/reports/profitsdiagnosis/profitview" component={TieredDev}  />

          <Route  path="/reports/profitsdiagnosis/revboost" component={Revboost}  />
          <Route  path="/reports/profitsdiagnosis/revboostretention" component={RevboostRetention}  />

          <Route  path="/reports/profitsdiagnosis/products" component={ProductsInfo}  />


          <Route  path="/reports/revboost/revboostchargebackdetail" component={RevboostChargebackDetail}  />
          
         

          <Route  path="/download/:type" component={DownloadTable} />


          

          <Route  path="/reports/DeclineReasonReport/" component={DeclineReasonReport}  />


          <Route  path="/reports/mastergatewayperformance/" component={MasterGatewayPerformance}  />

          <Route  path="/reports/vip/revenue" component={VipRevenue}  />
          <Route  path="/reports/vip/retention" component={VipRetention}  />

          <Route  path="/reports/CustomerServiceReports/NetworkvsKlaviyoReport" component={NetworkvsKlaviyoReport}  />

          <Route  path="/reports/CustomerServiceReports/csnoteswithoutcodes" component={Csnoteswithoutcodes}  />


          
          


          




          
          
          
          
         
      
         
        </div>
      </Router>
    );
  }
}

export default App;